/**
 * Near-identical Context Hub titles compare equal (ACT2-1129 duplicate check). NFKC; format characters
 * (zero-width and the like) become spaces; lower case; every run of characters that are not a letter, a
 * combining mark (so Hindi "कोट" ≠ "काट"), a digit or one of `+ < > $ #` becomes one space; trimmed. So case, spacing and punctuation do not matter,
 * but "Tier 1.5" ≠ "Tier 15", "MRR > $10k" ≠ "MRR < $10k" and "C#" ≠ "C++".
 */
export function normalizeContextTitle(title: string): string {
  return title
    .normalize('NFKC')
    .replace(/\p{Cf}/gu, ' ')
    .toLowerCase()
    .replace(/[^\p{L}\p{M}\p{N}+<>$#]+/gu, ' ')
    .trim();
}
